import { NO_LIGATURES_CLASS } from '@charitystack/shared';

/**
 * The About text on the overlay (CON-520, Paper 7CM-0 / 6PO-0): the nonprofit's rich text
 * in the primary ink, paragraphs 12px apart, links in the brand text role and always
 * underlined, headings 18/26 semibold, images on the control radius, ligatures off
 * ("501(c)(3)" must not become "501©(3)"). Typography's own palette is pointed at the
 * tokens so no `prose-*` default colour leaks through.
 *
 * Written as literal class strings so Tailwind emits them.
 */
const PROSE_BASE =
  'prose max-w-none font-normal text-[color:var(--cs-text-primary)] ' +
  '[--tw-prose-body:var(--cs-text-primary)] [--tw-prose-headings:var(--cs-text-primary)] ' +
  '[--tw-prose-bold:var(--cs-text-primary)] [--tw-prose-bullets:var(--cs-text-tertiary)] ' +
  '[--tw-prose-counters:var(--cs-text-tertiary)] [--tw-prose-links:var(--cs-brand-text,var(--cs-text-primary))] ' +
  'prose-p:my-0 prose-headings:mb-0 prose-headings:mt-0 prose-headings:font-semibold ' +
  'prose-headings:text-[length:var(--cs-text-lg)] prose-headings:leading-[var(--cs-leading-26)] ' +
  'prose-ul:my-0 prose-ol:my-0 prose-li:my-0 prose-a:font-normal prose-a:underline prose-a:decoration-1 ' +
  'prose-img:my-0 prose-img:rounded-[var(--cs-control-radius)] [&>*+*]:mt-[var(--cs-space-3)] ' +
  `${NO_LIGATURES_CLASS}`;

/** Desktop pane: 15/22. */
export const OVERLAY_PANE_DESCRIPTION_CLASS = `${PROSE_BASE} text-[length:var(--cs-text-sm-plus)] leading-[var(--cs-leading-22)]`;

/** Mobile layout: 16/24, like the hosted page. */
export const OVERLAY_MOBILE_DESCRIPTION_CLASS = `${PROSE_BASE} text-[length:var(--cs-text-base)] leading-[var(--cs-leading-24)]`;
